// extracted by mini-css-extract-plugin
export default {"sortDropdownButton":"SortingDropdown-module__sortDropdownButton--FnjUQ"};